import React from "react";
import { TspCard, TspDonutChart } from "../../../components/primitives";

export default function DistributionByMethod({ data, total }) {
  return (
    <TspCard title="Distribution by Method">
      <TspDonutChart data={data} centerLabel="Total Books" centerValue={total} />
    </TspCard>
  );
}
